  function getCandidateIds(stats) {
        let ids = {}
        stats.forEach(report => {
            if (report.type == "candidate-pair" && report.nominated && report.state == "succeeded") {
                //console.log("Found IDs")
                ids = {
                    localId: report.localCandidateId,
                    remoteId: report.remoteCandidateId
                }
            }
        });
        return ids
    }

    function getCandidateInfo(stats, candidateId) {
        let info = null
        stats.forEach(report => {
            if (report.id == candidateId) {
                // console.log("Found Candidate")
                info = report
            }
        })
        return info
    }

// types: https://developer.mozilla.org/en-US/docs/Web/API/RTCIceCandidateType
export async function getConnectionType(pc) {

    const candidates = await conncectionStats(pc)

    if (!candidates[0])
        return null;

    return candidates[0].candidateType
}

export async function conncectionStats(pc) {
        const stats = await pc.getStats(null)
        const candidates = await getCandidateIds(stats)
        // console.log("candidates: ", candidates)
        if (candidates !== {}) {
            const localCadidate = await getCandidateInfo(stats, candidates.localId)
            const remoteCadidate = await getCandidateInfo(stats, candidates.remoteId)
            if (localCadidate !== null && remoteCadidate !== null) {
                return [localCadidate, remoteCadidate]
            }
        }
        // we did not find the candidates for whatever reeason
        return [null, null]
    }